import { httpsCallable } from 'firebase/functions';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AsyncThunkCreator } from '../../../index';
import { SUBSCRIPTION_REDUCER_NAME } from '../types';

export interface PromotionCodeResult {
  valid: boolean;
  promotionCodeId?: string;
  percentOff?: number | null;
  amountOff?: number | null;
  currency?: string | null;
}

export const validatePromotionCode = createAsyncThunk<
  PromotionCodeResult,
  string,
  AsyncThunkCreator<number>
>(
  `${SUBSCRIPTION_REDUCER_NAME}/validatePromotionCode`,
  async (code, { rejectWithValue, extra: { functions } }) => {
    try {
      const res = await httpsCallable(functions, 'subscriptions-validatePromotionCode')({ code });
      return res.data as PromotionCodeResult;
    } catch (e) {
      const error = e as any;
      return rejectWithValue(error.message);
    }
  }
);
